// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/spotcp.css
// module id = 81
// module chunks = 0